import { render, staticRenderFns } from "./QuanLyKinhDoanh.vue?vue&type=template&id=bdff75d0"
import script from "./QuanLyKinhDoanh.vue?vue&type=script&lang=js"
export * from "./QuanLyKinhDoanh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports